import { ErrorInfo, createContext } from 'react';

type ErrorBoundaryContextState = {
  triggerError(args: { message?: string; error?: Error; errorInfo?: ErrorInfo }): void;
};

export const ErrorBoundaryContext = createContext<ErrorBoundaryContextState>({
  triggerError: ({ error }) => {
    console.error(error);
  },
});
